import callApi from 'common/callApi';
import {
  FETCH_CHITCHAT_MESSAGES_BEGIN,
  FETCH_CHITCHAT_MESSAGES_SUCCESS,
  FETCH_CHITCHAT_MESSAGES_FAILURE,
} from 'common/constants';
// import { CHIT_CHAT_RELATIONSHIPS } from 'common/chitChatTypes';

export const fetchChitChatBegin = bookingId => ({
  type: FETCH_CHITCHAT_MESSAGES_BEGIN,
  bookingId,
});

export const fetchChitChatSuccess = threads => ({
  type: FETCH_CHITCHAT_MESSAGES_SUCCESS,
  threads,
});

export const fetchChitChatFail = error => ({
  type: FETCH_CHITCHAT_MESSAGES_FAILURE,
  error,
});

export const fetchChitChat = (bookingId, eventLinkId) => dispatch => {
  dispatch(fetchChitChatBegin(bookingId));
  dispatch(callApi(`api/hpay/eventlink/${eventLinkId}/chitchat`)) // v1/chitChat/${CHIT_CHAT_RELATIONSHIPS.booking}/${bookingId}
    .then(result => result.json())
    .then(threads => dispatch(fetchChitChatSuccess(threads)))
    .catch(error => dispatch(fetchChitChatFail(error)));
};

export function saveNewChitChatThread(chitChatType, chitChatThread, eventLinkId) {

  return dispatch => dispatch(callApi(`api/hpay/eventlink/${eventLinkId}/chitChat/newThread`,
    { body: chitChatThread.baseMessage }));
}

export function saveChitChatComment(relationshipId, chitChatMessage, eventLinkId) {
  return dispatch => dispatch(callApi(`api/hpay/eventlink/${eventLinkId}/chitChat/${chitChatMessage.chitChatThreadId}/reply`,
    { body: chitChatMessage }));
}
